<div class="container-fluid">
  <!-- <div class="header-container">
    <div class="page-header">
      {{ 'bikeshop.shop_setup.header.rentals' | translate }} -> {{
      "bikeshop.shop_setup.card_headers._rental_products_and_accessories" | translate }}
    </div>
  </div> -->
  <div class="hubtiger-tab-container">
    <div (click)="selectedTab = 0" [ngClass]="{'selected' : selectedTab === 0}">{{ 'bikeshop.rentals.products.products' | translate }}</div>
    <div (click)="selectedTab = 1" [ngClass]="{'selected' : selectedTab === 1}">{{ 'bikeshop.rentals.products.accessories' | translate }}</div>
    <div (click)="selectedTab = 2" [ngClass]="{'selected' : selectedTab === 2}">{{ 'bikeshop.rentals.products.link_accessories_to_products' | translate }}</div>
  </div>
</div>

<div class="product-container" *ngIf="selectedTab === 0"><div [ngClass]="{'selected' : selectedTab === 0, 'unselected': selectedTab !== 0}"><app-rental-products></app-rental-products></div></div>
<div class="product-container" *ngIf="selectedTab === 1"><div [ngClass]="{'selected' : selectedTab === 1, 'unselected': selectedTab !== 1}"><app-rental-accessories></app-rental-accessories></div></div>
<div class="product-container" *ngIf="selectedTab === 2"><div [ngClass]="{'selected' : selectedTab === 2, 'unselected': selectedTab !== 2}"><app-rentals-link-accessories-products></app-rentals-link-accessories-products></div></div>
